const _fixtureContainers = new WeakSet<HTMLElement>();

const _originalFocus = HTMLElement.prototype.focus;
HTMLElement.prototype.focus = function (this: HTMLElement, options?: FocusOptions) {
	if (!options?.preventScroll && isInsideFixtureContainer(this)) {
		_originalFocus.call(this, { ...options, preventScroll: true });
	} else {
		_originalFocus.call(this, options);
	}
};

function isInsideFixtureContainer(el: HTMLElement): boolean {
	let node: Element | null = el;
	while (node) {
		if (node instanceof HTMLElement && _fixtureContainers.has(node)) {
			return true;
		}
		node = node.parentElement;
	}
	return false;
}

export function registerFixtureContainer(container: HTMLElement): void {
	_fixtureContainers.add(container);
}
